/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "./header";
import Menu from "./menu";
import WebMarket from "./sub_components/webmarket";
import Fancybook from "./fancybook";
import WinnerOdds from "./sub_components/winnerOddsMarket";
import Toast from "./sub_components/toast";
import * as orderService from "../services/orderService";
import * as tvService from "../services/tvService";
import * as providerIframeService from "../services/providerIframeService";
import * as eventService from "../services/eventService";
import * as utilService from "../services/utilService";
import * as rebateBonusService from "../services/rebateBonusService";

import ExpoPopup from "./sub_components/expoPopup";
import CricketBoard from "./score_boards/cricketBoard";
import SoccerBoard from "./score_boards/soccerBoard";
import TennisBoard from "./score_boards/tennisBoard";
import KabaddiBoard from "./score_boards/kabaddiBoard";
import ElectionBoard from "./score_boards/electionBoard";
import BetSlipPopup from "./sub_components/betSlipPopup";
// import marketMsg from './marketMsg.json';
import * as stringParser from "../util/string.util";
import { scoreFormatDate } from "../util/date.util";
import {
  FLASH_TV_URL,
  NANO_TV_URL,
  SHOW_LMT_IFRAME,
  SHOW_CRICKET_SCORE_IFRAME,
} from "../configs/commonConfigs";
import {
  BRANDLOGOFILENAME,
  SCORELOGOFILENAME,
} from "../configs/authSignupConfig";
import {
  staticContentsImagePath as BASE_IMAGE_PATH,
  OPERATOR_ID,
} from "../configs/const";
import { showRebateBonus } from "../configs/casinoShowList";
// import socketIOClient from "socket.io-client";
// import { SOCKET_ROOT as ENDPOINT } from '../configs/api';
import GraphicScore from "./score_boards/graphicScore";
import * as authUtil from "../util/auth.util";
import {
  calculateBetExpouser,
  calculateFancyMktExpouser,
  calculateFancyMktExpouserDemo,
} from "../util/expouser.util";
// const scoreSocket = socketIOClient(ENDPOINT);

class SportsBattleEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillUnmount() {}

  async componentDidMount() {}
  componentDidUpdate() {}
  getAccountData() {
    let data = localStorage.getItem("accountData");
    data = JSON.parse(data);
    return data;
  }
  updateSocket(skt) {}

  render() {
    // let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType")
    // fancyMarkets = this.orgenizedFancy(fancyMarkets)
    // let fmkt = this.arrayGroupBy(fancyMarkets, "marketType")
    // let maketTypeList = Object.keys(fmkt).map((fnc, i) => { return fnc = { mkt: fnc, count: fmkt[fnc].length } })
    // fancyMarkets = this.fancyFilterApply(fancyMarkets)
    // let bet_list = this.state.matched_bet
    // let gameCatalogues = !!this.state.game.catalogues ? this.sortGameCatalogues(this.state.game.catalogues) : []
    const accData = this.getAccountData();
    const prfdt = JSON.parse(localStorage.getItem("profData"));
    return (
      <body className="radheexch">
        <Header
          notify={this.props.notify}
          updateBetplaceStatus={() => {
            this.setState({ betPlaced: false });
          }}
          betPlaced={this.state.betPlaced}
          subscribe={(type, id) => {
            this.props.subscribe(type, id);
          }}
          subscriptions={this.props.subscriptions}
          history={this.props.history}
          socket={this.props.socket}
          updateSocket={(skt) => {
            this.updateSocket(skt);
          }}
          onMessage={(data) => {
            this.onMessage(data);
          }}
          updateXScore={(data) => {
            this.updateXScore(data);
          }}
          scoreData={this.state.scoreDetail}
          orderPlaced={(ord) => {
            this.orderPlaced(ord);
          }}
          resultDeclered={(type, payload) => {
            this.resultDeclered(type, payload);
          }}
        />
        <div
          className={`full-wrap mar-top100 footerpd footerpd ${
            !!accData && Object.keys(accData).length > 0
              ? ""
              : "mar-top100-login mar-bottom0"
          }`}
        >
          <Menu
            history={this.props.history}
            subscribe={(type, id) => {
              this.props.subscribe(type, id);
            }}
            subscriptions={this.props.subscriptions}
          />
          <div className="col-centersdetails markets">
            <div className="markets">
              <section>
                <div className="sub_path center-box">
                  <p>Punjab Kings vs Delhi Capitals</p>
                </div>
                <div className="container-fluid casino-content-page RDE sportsbattle-box ">
                  <div className="row mb-2 ">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="sportsbattlevent-inner  mt-2 mb-2">
                        <div className="sportsbattle-inner-top">
                          <div className="sportsbattle-title sportseventname-mobile">
                            Punjab Kings
                          </div>
                          <div className="sportsbattle-timebox">
                            06h 06m 43s
                          </div>
                          <div className="sportsbattle-title sportseventname-mobile">
                            {" "}
                            Delhi Capital
                          </div>
                        </div>
                        <div className="sportsbattle-inner-middle mb-2">
                          <div className="SBevent-logo-text sportsbattlew-33">
                            <div className="sportsbattle-title sportseventname-desktop">
                              Panjab Kings
                            </div>
                            <div>
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/punjab.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                          </div>
                          <div className="vsw80 text-center sportsbattlew-33">
                            <img
                              src={BASE_IMAGE_PATH + "/casino/team-img/vs.png"}
                              alt={""}
                            ></img>
                          </div>
                          <div className="SBevent-logo-text justify-content-end sportsbattlew-33">
                            <div>
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/mumbai.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="sportsbattle-title ml-2 sportseventname-desktop">
                              Mumbai Indians
                            </div>
                          </div>
                        </div>
                        <div className="sbevent-footer-btn">
                          <div className="sbevent-player-btn playerstart-bg br-right">
                            PLAYER START
                          </div>
                          <div className="sbevent-player-btn computerstart-bg br-rl">
                            COMPUTER START
                          </div>
                          <div className="sbevent-myteam-btn d-flex">
                            <div className="sbevent-myteam-button">
                              MY TEAM - (2)
                            </div>
                            <div className="sbevent-myteam-button sbevent-active">
                              ADD TEAM
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- ===== PLAYER LIST TITLE START ===== --> */}
                  <div className="row mb-2 ">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className=" playerlist-box">Player list</div>
                    </div>
                  </div>
                  {/* <!-- ===== PLAYER LIST TITLE END ===== --> */}
                  {/* <!-- ===== PLAYER NAME START ===== --> */}
                  <div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="row sportsbattleplayerlist">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                          <div className="team-name-text">
                            Team 1: Punjab Kings
                          </div>
                          <div className="team-player-box">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/shreyas-iyer.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Shreyas Iyer
                            </div>
                          </div>
                          <div className="team-player-box">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/marcus-stoinis.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Marcus Stoinis
                            </div>
                          </div>
                          <div className="team-player-box computer-select">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/yuzvendra-chahal.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Yuzvendra Chahal
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                          <div className="team-name-text">
                            Team 2: Mumbai Indians
                          </div>
                          <div className="team-player-box">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/rohit-sharma.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Rohit Sharma
                            </div>
                          </div>
                          <div className="team-player-box">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/Surya-kumar-yadav.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Surya Kumar Yadav
                            </div>
                          </div>
                          <div className="team-player-box">
                            <div className="team-player-images">
                              <img
                                src={
                                  BASE_IMAGE_PATH +
                                  "/casino/team-img/jasprit-bumrah.png"
                                }
                                alt={""}
                              ></img>
                            </div>
                            <div className="team-player-name-text">
                              Jasprit Bumrah
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- ===== PLAYER NAME END ===== --> */}
                  <div className="row ">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className=" playerlist-box">Bet Slip</div>
                    </div>
                  </div>
                  {/* Bet slip start */}
                  <div class="row mb-2">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="playerlist-betslip">
                        Bet with Team
                        <a class="float-right ">
                          <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 desktop-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>

                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MOBILE BET SLIP */}
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mobile-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>
                        </div>
                        <div className="betsliptbox mt-1">
                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END MOBILE BET SLIP */}
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="playerlist-betslip">
                        Bet with Run
                        <a class="float-right ">
                          <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 desktop-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>

                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MOBILE BET SLIP */}
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mobile-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>
                        </div>
                        <div className="betsliptbox mt-1">
                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END MOBILE BET SLIP */}
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="playerlist-betslip">
                        Bet with Ball
                        <a class="float-right ">
                          <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 desktop-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>

                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MOBILE BET SLIP */}
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mobile-betslip">
                      <div className="sportsbattle-betslipbox">
                        <div className="betsliptbox">
                          <button className="betsliptbox-bg mr-1">100</button>
                          <button className="betsliptbox-bg mr-1">500</button>
                          <button className="betsliptbox-bg mr-1">1000</button>
                          <button className="betsliptbox-bg mr-1">15000</button>
                        </div>
                        <div className="betsliptbox mt-1">
                          <button className="betsliptbox-edit sportw-10 mr-1">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                          </button>
                          <div className="sportw-60 mr-1">
                            <input
                              className="sportbattle-place_input"
                              placeholder="enter amount"
                            ></input>
                          </div>
                          <div className="sportw-30">
                            <button className="sportsbattle-place_bet">
                              Place Bet
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END MOBILE BET SLIP */}
                  </div>
                </div>
              </section>
            </div>
          </div>

          <div
            className={`col-right ${
              !!accData && Object.keys(accData).length > 0
                ? ""
                : "col-right-login"
            }`}
          >
            <div className="sub_path over-wrap">
              <div className="center-box">
                <div className="container-fluid titbg">
                  <div className="w-100 float-left">
                    <span
                      onClick={() => {
                        this.setState({ selected_list: "matched" });
                      }}
                      className={
                        this.state.selected_list === "matched"
                          ? "betslip-btn active"
                          : "betslip-btn"
                      }
                    >
                      Matched Bet
                    </span>
                    <a
                      className="view-more-btn"
                      onClick={() => {
                        this.setState({ betSlipOpen: true });
                      }}
                      data-toggle="modal"
                      data-target="#mystatement"
                    >
                      View More
                    </a>
                  </div>
                </div>
                <div className="mybet-alldata bg-white table-responsive">
                  <table className="table table-bordered nowrap table-sm font-12 mb-4">
                    <thead>
                      <tr className="bg-dark text-white">
                        <th>Matched Bet</th>
                        <th>Odds</th>
                        <th>Stake</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(SportsBattleEvent);
